import { useHistory } from "react-router-dom";
import { setPendingVerificationModal } from "src/store/features/modals.slice";
import { useUserSlice } from "src/store/features/user.slice";
import { useAppDispatch } from "src/store/store";

/**
 * Custom hook to handle verification-related navigation and actions
 *
 * @returns {Object} Object containing utility functions for verification handling
 */
export const useVerificationNavigation = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { isUnverified, isPendingVerification } = useUserSlice();

  /**
   * Handles verification navigation based on user verification status
   *
   * @param {Function} [options.onSuccess] Callback to run if user is verified
   * @returns {void}
   */
  const handleVerification = (onSuccess?: () => void) => {
    if (isUnverified) {
      history.push("/application");
      return;
    }
    if (isPendingVerification) {
      dispatch(setPendingVerificationModal(true));
      return;
    }

    if (onSuccess && typeof onSuccess === "function") {
      onSuccess();
    }
    return;
  };

  return {
    handleVerification,
  };
};

export default useVerificationNavigation;
